import React, { useState } from 'react';
import { submitContactForm } from '../services/firebaseService';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const result = await submitContactForm(formData);
      
      if (result.success) {
        alert('Thank you for your message! We\'ll get back to you within 24 hours.');
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      } else {
        alert('There was an error sending your message. Please try again or contact us directly.');
        console.error('Contact form error:', result.error);
      }
    } catch (error) {
      alert('There was an error sending your message. Please try again or contact us directly.');
      console.error('Contact submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-12 bg-gradient-to-br from-burlap-50 to-cream-50 px-4">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-10">
          <span className="text-sm font-bold text-primary-600 uppercase tracking-wider bg-primary-100 px-4 py-2 rounded-full mb-4 inline-block">
            Get In Touch
          </span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-burlap-800 mb-4">
            Let's Create Something <span className="gradient-gold">Amazing</span>
          </h2>
          <p className="text-lg text-burlap-600 max-w-2xl mx-auto">
            Ready to find the perfect gift? Let's discuss your needs
          </p>
        </div>

        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 lg:p-8 border border-cream-200">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-300 placeholder-gray-400 bg-white/90"
                placeholder="Your Name *"
              />
              
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-300 placeholder-gray-400 bg-white/90"
                placeholder="Email Address *"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-300 placeholder-gray-400 bg-white/90"
                placeholder="Phone Number"
              />
              
              <select
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-300 bg-white/90 appearance-none"
              >
                <option value="">Select Subject</option>
                <option value="general">General Inquiry</option>
                <option value="custom-order">Custom Order</option>
                <option value="corporate">Corporate Gifts</option>
                <option value="support">Support</option>
              </select>
            </div>

            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="4"
              className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-300 resize-none placeholder-gray-400 bg-white/90"
              placeholder="Tell us about your project or inquiry *"
            ></textarea>

            <button
              type="submit"
              disabled={isSubmitting}
              className={`w-full py-3 px-6 rounded-xl font-semibold text-white transition-all duration-300 ${
                isSubmitting 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-gradient-to-r from-primary-500 to-accent-500 hover:from-primary-600 hover:to-accent-600 transform hover:scale-[1.02] shadow-lg hover:shadow-xl'
              }`}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>

          {/* Quick Contact Info */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-burlap-800 mb-3">Contact Information</h4>
                <div className="space-y-2">
                  <div className="flex items-center space-x-2">
                    <span className="text-primary-500">📧</span>
                    <span className="text-sm text-burlap-600">kalaratans.gifts@gmail.com</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-primary-500">📱</span>
                    <span className="text-sm text-burlap-600">+91 8748845182</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-primary-500">🕒</span>
                    <span className="text-sm text-burlap-600">Mon-Sat: 9AM - 6PM</span>
                  </div>
                </div>
              </div>
              <div>
                <h4 className="font-semibold text-burlap-800 mb-3">Visit Our Store</h4>
                <div className="flex items-start space-x-2">
                  <span className="text-primary-500 mt-1">�</span>
                  <div className="text-sm text-burlap-600">
                    <div>Kalaratan's gifts,</div>
                    <div>4th cross, Balaji Street,</div>
                    <div>Ramamurthy Nagar,</div>
                    <div>Bangalore, Karnataka, India.</div>
                    <div>Pincode: 560016</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
